import * as angular from 'angular';
import * as ngRouteModule from 'angular-route';

import ApiModule from '../api/api.module';
import CoreModule from '../core/core.module';
import NavigationModule from '../navigation/navigation.module';

import { CategoryAddendaComponent } from './categoryAddenda/categoryAddenda.component';
import { CompareRfiComponent } from './main/compareRfi.component';
import { RfiResponsesComponent } from './rfiResponses/rfiResponses.component';

export default angular
  .module('CompareRfiModule', [
    ApiModule,
    CoreModule,
    NavigationModule,
    ngRouteModule,
    'aptitude',
    'mgcrea.ngStrap',
    'apt.ux',
    'Aptitude.TimelineModule'
  ])
  .component('categoryAddenda', CategoryAddendaComponent)
  .component('compareRfi', CompareRfiComponent)
  .component('rfiResponses', RfiResponsesComponent)
  .config(($routeProvider) => {
    'use strict';
    'ngInject';

    if (angular.element('[ng-app]').attr('ng-app') === 'CompareRfiModule') {
      // FIXME: this hack is to prevent the routes in this module from conflicting with the routes in a "parent" module
      $routeProvider.when('/:rfpId', {
        template: '<compare-rfi></compare-rfi>'
      });
    }
  }).name;
